import React, { useState } from 'react';
import ModelTester from './ModelTester';

function ProviderForm({ formData, setFormData, onSubmit, onCancel, editing }) {
  const [showTester, setShowTester] = useState(false);
  const update = (field, value) => setFormData({ ...formData, [field]: value });

  const canTest = formData.base_url && formData.api_key;

  return (
    <form onSubmit={onSubmit} className="provider-form">
      <div className="form-row">
        <div className="form-group">
          <label>Provider Name *</label>
          <input type="text" value={formData.name}
            onChange={(e) => update('name', e.target.value)}
            placeholder="e.g., My Groq Account" required />
        </div>
        <div className="form-group">
          <label>Base URL *</label>
          <input type="url" value={formData.base_url}
            onChange={(e) => update('base_url', e.target.value)}
            placeholder="https://api.groq.com/openai/v1" required />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>API Key *</label>
          <input type="password" value={formData.api_key}
            onChange={(e) => update('api_key', e.target.value)}
            placeholder="Your API key" required />
        </div>
        <div className="form-group">
          <label>Alias (optional)</label>
          <input type="text" value={formData.alias}
            onChange={(e) => update('alias', e.target.value)}
            placeholder="e.g., gpt-3.5-turbo" />
          <small>Apps request this name; proxy maps to actual model</small>
        </div>
      </div>

      {/* Model Tester Section - appears when endpoint + key are provided */}
      {canTest && (
        <div className="form-section">
          <button
            type="button"
            onClick={() => setShowTester(!showTester)}
            className="btn btn-outline"
          >
            {showTester ? 'Hide Model Tester' : 'Test Models from Endpoint'}
          </button>
          {showTester && (
            <ModelTester
              baseUrl={formData.base_url}
              apiKey={formData.api_key}
              onModelsTested={(models) => {
                // Store tested models in formData for later use
                setFormData(prev => ({ ...prev, testedModels: models }));
              }}
            />
          )}
        </div>
      )}

      <div className="form-row">
        <div className="form-group">
          <label>Request Limit (0 = unlimited)</label>
          <input type="number" value={formData.request_limit}
            onChange={(e) => update('request_limit', parseInt(e.target.value) || 0)} />
        </div>
        <div className="form-group">
          <label>Token Limit (0 = unlimited)</label>
          <input type="number" value={formData.token_limit}
            onChange={(e) => update('token_limit', parseInt(e.target.value) || 0)} />
        </div>
        <div className="form-group">
          <label>Reset Period (hours)</label>
          <input type="number" value={formData.reset_period_hours}
            onChange={(e) => update('reset_period_hours', parseInt(e.target.value) || 24)} />
        </div>
      </div>
      <div className="form-actions">
        <button type="submit" className="btn btn-primary">
          {editing ? 'Update Provider' : 'Add Provider'}
        </button>
        <button type="button" onClick={onCancel} className="btn btn-outline">Cancel</button>
      </div>
    </form>
  );
}

export default ProviderForm;
